import { GuestDetails, RsvpDetails, StepsTranslationsStrings } from "../../models/api/rsvpApiTypes"
import { CORE_STEP_NAMES, TranslationsStringsType } from "../../models/enum/rsvpEnum"
import useStepNavigation from "../../hook/useStepNavigation"
import { DATE_FORMAT } from "../../utils/dateFormat"
import DateInput from "../Inputs/DateInput"

interface StepDateProps {
  buttonColor?: string
  backButtonColor?: string
  strings?: StepsTranslationsStrings[]
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  setStep: (name: string) => void
  stepPipeline: string[]
}

export default function StepDate({
  buttonColor,
  backButtonColor,
  strings,
  rsvp,
  setStep,
  stepPipeline,
  setRsvp,
}: StepDateProps) {
  const { goNext, goPrevious } = useStepNavigation(stepPipeline, CORE_STEP_NAMES.ARRIVAL_DATE, setStep)

  const setDate = (arrivalDate: Date | null, guest: GuestDetails) => {
    const newGuests = rsvp.invitation.guests.map((g) => {
      if (g.id === guest.id) {
        g = {
          ...guest,
          rsvp: {
            accepted: g.rsvp.accepted,
            arrivalDate,
            email: g.rsvp.email,
            intolerances: g.rsvp.intolerances,
            busTransferNeeded: g.rsvp.busTransferNeeded,
          },
        }
      }
      return g
    })
    setRsvp({ ...rsvp, invitation: { ...rsvp.invitation, guests: newGuests } })
  }

  return (
    <>
      {rsvp.invitation.guests.map((guest) => (
        <div key={guest.id} style={{ marginTop: "5px" }}>
          {guest.rsvp.accepted && guest.rsvpSettings.showArrivalDate && (
            <>
              <label className="box-form-label">
                {guest.name} {guest.surname}
              </label>
              <DateInput
                className="box-form-input"
                selected={guest.rsvp.arrivalDate ? new Date(guest.rsvp.arrivalDate) : null}
                dateFormat={DATE_FORMAT}
                onChange={(date: Date | null) => setDate(date, guest)}
              />
            </>
          )}
        </div>
      ))}

      <div style={{ display: "flex", flexDirection: "row" }}>
        <button
          style={{ backgroundColor: backButtonColor, borderColor: backButtonColor }}
          type="button"
          className="btn btn-primary box-button-left"
          onClick={goPrevious}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.LEFTBUTTON)?.value}
        </button>
        <button
          type="button"
          className="btn btn-primary box-button-right"
          style={{ backgroundColor: buttonColor, borderColor: buttonColor }}
          onClick={goNext}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.MAINBUTTON)?.value}
        </button>
      </div>
    </>
  )
}
